import styled, { css } from 'styled-components';
import { BORDER_RADIUS, COLOURS, media, mediaMap, SHADOWS, SPACES } from '@belong/themes';
import { ResponsiveProp, ShadowsKey, SpacesKeys, StyledCSS } from '@belong/types';
import { responsiveValue } from '@belong/ui-core';

export interface IContainerProps {
  containsForm?: boolean;
  shadowVariant?: ShadowsKey;
  /**
   * If the card should render with a border, shadow or no outline (undefined)
   */
  borderVariant?: 'shadow' | 'border';
  hasPadding?: ResponsiveProp<SpacesKeys>;
}

export const Container = styled.div<IContainerProps>`
  background: ${({ theme }) => COLOURS[theme.card.backgroundColor]};
  border-radius: ${BORDER_RADIUS.CARD};

  ${({ hasPadding }): ReturnType<typeof css> => {
    return (
      hasPadding &&
      mediaMap(
        responsiveValue(hasPadding),
        (padding: SpacesKeys) => css`
          padding: ${SPACES[padding]}rem;
        `
      )
    );
  }}

  /* --- [ Shadow / border rules ] ----------------------------- */
  ${({ containsForm, borderVariant, shadowVariant = 'KEY_LIGHT' }): StyledCSS => {
    if (containsForm) {
      return css`
        box-shadow: none;

        ${media('md')`
          box-shadow: ${SHADOWS[shadowVariant]};
        `}
      `;
    }

    if (!borderVariant) {
      return '';
    }

    return borderVariant === 'border'
      ? css`
          border: solid 1px ${({ theme }) => COLOURS[theme.card.borderColor]};
        `
      : css`
          box-shadow: ${SHADOWS[shadowVariant]};
        `;
  }}
`;
